import React from 'react';
import { Wrap, Image, Text } from './Loader.styled';
import Label from '../Label';
import useLabel from 'src/hooks/useLabel';

const Loader = () => {
  const getLabel = useLabel();
  const labelName = 'Triumph.Dealers.Loading';
  const loadingLabel = getLabel(labelName);

  return (
  <Wrap>
    <Image src="/images/dealer-locator/loading.gif" alt="Loading" />
    <Text>
      {loadingLabel === labelName ? <>&nbsp;</> : loadingLabel}
    </Text>
  </Wrap>
)};

export default Loader;
